import React from "react";

// ✅ Import images instead of hardcoding
import service1 from "../../Assets/img/Service 1.png";
import service2 from "../../Assets/img/Service 2.png";
import service3 from "../../Assets/img/Service 3.png";
import service4 from "../../Assets/img/Service 4.png";

import icon1 from "../../Assets/img/01icon.svg";
import icon2 from "../../Assets/img/02icon.svg";
import icon3 from "../../Assets/img/03icon.svg";
import icon4 from "../../Assets/img/04icon.svg";

const HiringSolutions = () => {
  return (
    <section className="container-card ">
      <div className="container Apply-padding">
        <h2 className="text-center font-weight-600 font-size: 2rem mb-4">
          Our Hiring Solutions
        </h2>
        <p className="text-muted mx-auto mb-4">
          Our Hiring Solutions are designed to help businesses find the right
          talent quickly and efficiently. From permanent staffing to
          project-based hiring, we deliver customized recruitment strategies
          tailored to your industry needs.
        </p>

        <div className="row gx-4 gy-4">
          {/* Card 1 */}
          <div className="col-md-6 col-lg-3">
            <div className="card card1 card-outline-purple rounded-3 p-2">
              <div className=" d-flex justify-content-between align-items-center mb-3">
                <div className="number-icon">01</div>
                <div className="icon-purple">
                  <img src={icon1} alt="Icon 1" />
                </div>
              </div>
              <h5 className="card-title-1">Recruitment</h5>
              <p className="card-text-1">
                Hire the right candidates faster with our expert recruitment
                solutions tailored to your business needs.
              </p>
              <div className="underline-purple"></div>
              <a
                href="/service"
                className="explore-btn mt-auto d-block text-decoration-none"
              >
                Explore More
              </a>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 col-lg-3">
            <div className="card card2 card-outline-purple rounded-3 p-2">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="number-icon">02</div>
                <div className="icon-purple">
                  <img src={icon2} alt="Icon 2" />
                </div>
              </div>
              <h5 className="card-title-1">Recruitment Process Outsourcing</h5>
              <p className="card-text-1">
                Recruit smarter with our flexible RPO services that enhance
                efficiency, lower costs, and ensure quality hires.
              </p>
              <div className="underline-purple"></div>
              <a
                href="/service"
                className="explore-btn mt-auto d-block text-decoration-none"
              >
                Explore More
              </a>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-6 col-lg-3">
            <div className="card card3 card-outline-purple rounded-3 p-2">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="number-icon">03</div>
                <div className="icon-purple">
                  <img src={icon3} alt="Icon 3" />
                </div>
              </div>
              <h5 className="card-title-1">International Recruitment</h5>
              <p className="card-text-1">
                Access a global talent pool with our expert-led international
                hiring services tailored to your industry needs.
              </p>
              <div className="underline-purple"></div>
              <a
                href="/service"
                className="explore-btn mt-auto d-block text-decoration-none"
              >
                Explore More
              </a>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-md-6 col-lg-3">
            <div className="card card4 card-outline-purple rounded-3 p-2">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="number-icon">04</div>
                <div className="icon-purple">
                  <img src={icon4} alt="Icon 4" />
                </div>
              </div>
              <h5 className="card-title-1">Complete HR Solutions</h5>
              <p className="card-text-1">
                Connect with top international candidates using our customized
                global hiring services.
              </p>
              <div className="underline-purple"></div>
              <a
                href="/service"
                className="explore-btn mt-auto d-block text-decoration-none"
              >
                Explore More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HiringSolutions;
